import React from 'react';
import { FIELD_NAME } from '../../constants/form-constants';
import { isComerciales } from '../../helpers/carline-helpers';
import { InputsGroup } from '../screen/inputs-group';
import { CodigoPostalInput } from './inputs/codigo-postal-input';
import { EmailInput } from './inputs/email-input';
import { LettersInput } from './inputs/letters-input';
import { TelefonoInput } from './inputs/telefono-input';
import { TratoNombreInput } from './inputs/trato-nombre-input';

interface Props {
	hideEmail?: boolean;
	hideTelefono?: boolean;
	hideCodigoPostal?: boolean;
}

export function DatosPersonalesInputsGroup(props: Props) {
	const { hideEmail, hideTelefono, hideCodigoPostal } = props;

	return (
		<InputsGroup>
			{isComerciales() ? <TratoNombreInput /> : <LettersInput name={FIELD_NAME.NAME} required />}
			<LettersInput name={FIELD_NAME.SURNAME_1} label="Primer apellido" required />
			{!hideEmail && <EmailInput required />}
			{!hideTelefono && <TelefonoInput required />}
			{!isComerciales() ? null : !hideCodigoPostal && <CodigoPostalInput required />}
		</InputsGroup>
	);
}
